import React from "react";
import { Link, useParams } from "react-router-dom";
import { FaArrowLeft, FaCheck, FaDownload, FaFilePdf } from "react-icons/fa";
import guides from "./guideData";
import "./GuideDetail.css";

export default function GuideDetail() {
  const { slug } = useParams();
  const guide = guides.find((item) => item.slug === slug);
  const nextGuide = guide && guides.find((item) => item.order === guide.order + 1);

  if (!guide) {
    return (
      <section className="guide-detail guide-not-found">
        <h1>Guide not found</h1>
        <Link to="/guide">Return to all guides</Link>
      </section>
    );
  }

  return (
    <article className="guide-detail">
      <Link to="/guide" className="guide-back"><FaArrowLeft /> All guides</Link>
      <header className="guide-detail-hero">
        <p>For {guide.audience}</p>
        <h1>{guide.title}</h1>
        <span>{guide.description}</span>
        {guide.file && <a href={`/guides/${guide.file}`} target="_blank" rel="noopener noreferrer" className="guide-download">
          <FaFilePdf /> View {guide.title} PDF <FaDownload />
        </a>}
      </header>

      <nav className="guide-contents" aria-label="On this page">
        <h2>In this guide</h2>
        <ol>{guide.steps.map(([title], index) => <li key={title}><a href={`#step-${index + 1}`}>{title}</a></li>)}</ol>
      </nav>
      <section className="guide-steps" aria-label={`${guide.title} steps`}>
        <h2>Step-by-step</h2>
        {guide.steps.map(([title, detail], index) => (
          <div className="guide-step" id={`step-${index + 1}`} key={title} tabIndex={-1}>
            <span className="guide-step-number">{index + 1}</span>
            <div><h3>{title}</h3><p>{detail}</p></div>
          </div>
        ))}
      </section>

      <aside className="guide-tips">
        <h2>Helpful tips</h2>
        <ul>{guide.tips.map((tip) => <li key={tip}><FaCheck /> {tip}</li>)}</ul>
      </aside>
      <nav className="guide-next" aria-label="Continue learning">
        <Link to="/guide">Browse all guides</Link>
        {nextGuide && <Link to={`/guide/${nextGuide.slug}`}>Next: {nextGuide.title} →</Link>}
      </nav>
    </article>
  );
}
